<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("branches.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('branches.name') })" v-model="form.name" :label='$t("branches.name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("branches.business_name_placeholder")' :danger="$v.form.business_name.$invalid && $v.form.business_name.$model" :danger-text="$t('validation.required', { attribute: $t('branches.business_name') })" v-model="form.business_name" :label='$t("branches.business_name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("branches.address_placeholder")' :danger="$v.form.address.$invalid && $v.form.address.$model" :danger-text="$t('validation.required', { attribute: $t('branches.address') })" v-model="form.address" :label='$t("branches.address")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Branches')

export default {
  name: 'ModalBranches',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        name: {
          required
        },
        business_name: {
          required
        },
        address: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ])
  }
}
</script>
